<template>
    <div class="container barcode-container">
        <!-- Loading -->
        <loading-state
                v-if="!showScanner"
                centered
                overlay
                title="Loading scanner">
        </loading-state>

        <button class="barcode-reload btn" title="Reload scanner" v-if="showScanner" @click="reloadBarcodeScanner"><icon-reload class="icon-all-body icon-chunky" size="sm"></icon-reload></button>
        <div id="barcode-picker" class="barcode-picker"></div>
    </div>
</template>

<script>
    import {BarcodeScanned} from "@/models/barcodeScanned";
    import {mapActions, mapGetters} from "vuex";

    export default {
        props: {
            resumeDelay: {
                type: Number,
                default: 2000
            },
            inModal: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                clearJsonTimeout: null,
                componentIsDestroyed: false,
                jsonString: "",
                showScanner: false
            }
        },

        mounted() {
            let self = this;
            setTimeout(() => {
                self.initialiseBarcodeScanner();
            }, 500);
            this.listenForBarcodeScanner();
        },

        beforeDestroy() {
            if (!this.inModal) {
                this.componentIsDestroyed = true;
                this.destroyBarcodeScanner();
            }
        },

        computed: {
            ...mapGetters([
                'barcodePicker',
                'barcodeScanned',
                'barcodeScanner'
            ])
        },

        methods: {
            ...mapActions([
                'destroyBarcodeScanner',
                'displayToast',
                'setBarcodeScanner',
                'setBarcodeScanned'
            ]),

            handleBarcodeScanned(data) {
                this.setBarcodeScanned(data);

                let barcodeScanned = data;

                if (this.isJson(data)) {
                   barcodeScanned = new BarcodeScanned(JSON.parse(data));
                }

                this.$emit("barcodeHasBeenScanned", barcodeScanned);
            },

            initialiseBarcodeScanner() {
                if (this.barcodeScanner !== null && !this.barcodeScanner.destroyed) {
                    return;
                }

                let self = this;

                this.$scandit.BarcodePicker.create(document.getElementById("barcode-picker"), {
                    accessCamera: true,
                    cameraType: "back",
                    guiStyle: "viewfinder",
                    isTapToFocusEnabled: true,
                    isTorchToggleEnabled: true,
                    objectFit: "cover",
                    playSoundOnScan: true,
                    vibrateOnScan: false,
                    singleImageMode: {
                        desktop: {
                            allowFallback: true,
                            always: false
                        },
                        mobile: {
                            allowFallback: true,
                            always: false
                        },
                    },
                }).then(barcodePicker => {

                    self.showScanner = true;

                    const scanSettings = new self.$scandit.ScanSettings({
                        // enabledSymbologies: ["qr", "microqr", "data-matrix"]
                        enabledSymbologies: ["ean8", "ean13", "upca", "upce", "code128", "code39", "code93", "qr", "microqr", "data-matrix", "itf"]
                    });

                    // scanSettings.setCodeDuplicateFilter(-1);

                    barcodePicker.applyScanSettings(scanSettings);

                    barcodePicker.on("scan", function(scanResult) {

                        self.handleBarcodeScanned(scanResult.barcodes[0].data);

                        barcodePicker.pauseScanning();

                        setTimeout(() => {
                            barcodePicker.resumeScanning();
                        }, self.resumeDelay);
                    });

                    self.setBarcodeScanner(barcodePicker);

                    if (self.componentIsDestroyed) {
                        self.destroyBarcodeScanner();
                    }
                })
                .catch(error => {
                    self.displayToast({text: error, type: 'error'});
                });
            },

            /** Listen out for the hand held barcode scanner */
            listenForBarcodeScanner() {
                let self = this;
                document.addEventListener('keypress', (event) => {
                    clearTimeout(self.clearJsonTimeout);

                    if (event.key.length === 1) {
                        if (event.key === "@") {
                            self.jsonString += '"';
                        } else {
                            self.jsonString += event.key;
                        }
                    }

                    if (event.code === "Enter") {
                        self.handleBarcodeScanned(self.jsonString);
                    }

                    self.clearJsonTimeout = setTimeout(() => {
                        self.searching = false;
                        self.jsonString = "";
                    }, 1000);
                });
            },

            /** Check if string is valid json */
            isJson(string) {
                try {
                    JSON.parse(string);
                } catch (e) {
                    return false;
                }
                return true;
            },

            reloadBarcodeScanner() {
                this.destroyBarcodeScanner()
                    .then(() => {
                        this.initialiseBarcodeScanner();
                    });
            }
        }
    }
</script>